import { Award, Trophy, Star, Medal, Users } from "lucide-react";

interface BadgeIconProps {
  badgeType: string;
  className?: string;
}

export const BadgeIcon = ({ badgeType, className = "w-4 h-4" }: BadgeIconProps) => {
  switch (badgeType) {
    case 'tutorial_completed':
      return <Star className={className} />;
    case 'first_routine':
      return <Trophy className={className} />;
    case 'first_class':
      return <Medal className={className} />;
    case 'workout_streak':
      return <Award className={className} />;
    case 'class_enthusiast':
      return <Users className={className} />;
    default:
      return <Award className={className} />;
  }
};